import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "p-the-page-error c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "p-the-page-error__inner c-common-inner" }
const _hoisted_4 = {
  key: 0,
  class: "p-the-page-error__sub_title__text"
}
const _hoisted_5 = { class: "p-the-page-error__message" }
const _hoisted_6 = { class: "p-form-button-group" }
const _hoisted_7 = { class: "p-form-button-group__vertical" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheSimpleHeader = _resolveComponent("TheSimpleHeader")!
  const _component_CommonHeading = _resolveComponent("CommonHeading")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TheSimpleHeader),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CommonHeading, { class: "p-the-page-error__heading" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.errorTitleText), 1)
          ]),
          _: 1
        }),
        (_ctx.errorSubTitleText)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.errorSubTitleText), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorMessageTexts, (messageText, key) => {
            return (_openBlock(), _createElementBlock("p", {
              class: "p-the-page-error__message__text",
              key: key
            }, _toDisplayString(messageText), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_ButtonMain, {
              kind: "cancel",
              onClickButton: _ctx.buttonAction
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.errorButtonText), 1)
              ]),
              _: 1
            }, 8, ["onClickButton"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_TheFooter)
  ]))
}